// Ellipse Branding Configuration
// Centralized theme constants for key UI components

// Helper: Get Config (Synchronous Read)
const getBranding = () => {
    try {
        const saved = localStorage.getItem('ellipse_branding');
        return saved ? JSON.parse(saved) : null;
    } catch (e) { return null; }
};
const config = getBranding();

// Default Fallbacks
const DEFAULT_BLUE = '#92d1dc'; // Primary Brand Color
const DEFAULT_GREEN = '#bfd56c'; // Secondary Brand Color
const DEFAULT_YELLOW = '#f5d377'; // Tertiary Brand Color

export const BRAND_COLORS = {
    primary: '#0f172a',    // Dark Slate (Text, Primary Backgrounds)
    secondary: '#334155',  // Lighter Slate (Subtext)
    accent: config?.secondaryColor || DEFAULT_GREEN,     // Ellipse Green (Highlights, Buttons)
    blue: config?.primaryColor || DEFAULT_BLUE,       // Brand Blue (Hero Backgrounds)
    yellow: config?.tertiaryColor || DEFAULT_YELLOW, // Brand Yellow
    white: '#ffffff',
    glass: 'rgba(255, 255, 255, 0.1)',
    error: '#ef4444'
};

const shadowColor = config?.primaryColor ? `${config.primaryColor}66` : 'rgba(146, 209, 220, 0.4)';

export const HERO_STYLE = {
    background: config?.primaryColor || DEFAULT_BLUE, // Dynamic Brand Blue
    color: '#0f172a',      // Dark Text
    borderRadius: 8,       // ~32px in MUI theme (8 * 4)
    boxShadow: `0 20px 40px ${shadowColor}`,
    overflow: 'hidden',
    position: 'relative'
};

export const TEXT_STYLES = {
    heroTitle: {
        color: '#0f172a',
        fontWeight: 800,
        lineHeight: 1.1
    },
    heroSubtitle: {
        color: '#334155',
        lineHeight: 1.6
    },
    sectionTitle: {
        color: '#0f172a',
        fontWeight: 800,
        letterSpacing: '-0.02em'
    }
};
